<template>
  <el-tabs tab-position="left" v-model="tabActive">
    <el-tab-pane label="LuckyWheel" name="LuckyWheel">
      <LoopMachineTabData :loop-data="allData.LuckyWheel"/>
    </el-tab-pane>
<!--    <el-tab-pane label="NonStopOffer" name="NonStopOffer">-->
<!--      <LoopMachineTabData :data="allData.NonStopOffer"/>-->
<!--    </el-tab-pane>-->
    <el-tab-pane label="Recharge" name="Recharge">
      <LoopMachineTabData :loop-data="allData.Recharge"/>
    </el-tab-pane>
<!--    <el-tab-pane label="Wheel" name="Wheel">-->
<!--      <LoopMachineTabData :data="allData.Wheel"/>-->
<!--    </el-tab-pane>-->
  </el-tabs>
</template>

<script>

import LoopMachineTabData from "./LoopMachineTabData.vue"

function noop() {}

export default {
  name: "loopMachine",
  components: {
    LoopMachineTabData
  },
  props: {
    allData : {},
  },
  data: () => {
    return {
      tabActive: "LuckyWheel",
    }
  },
  methods: {
    onChangeDataLb(typeEvent) {
    },
  },
  computed: {
  },
};

</script>